import clsx from 'clsx';
import React from 'react';
import { createUseStyles } from 'react-jss';

import { media } from '../../utils/constants';

const useStyles = createUseStyles((theme) => ({
  sidebar: {
    [media.xxlUp]: {
      width: 300,
    },
    [media.xxlDown]: {
      width: '15vw',
    },
    [media.lgDown]: {
      width: '20vw',
    },
    [media.mdDown]: {
      width: '26vw',
    },
    [media.smDown]: {
      width: '96%',
    },
  },
  sidebarContent: {
    [media.smUp]: {
      marginTop: theme.spacing(32),
    },
  }
}));

const Sidebar = ({ children, className }) => {
  const classes = useStyles();

  return (
    <div className={clsx(classes.sidebar, className)}>
      <div className={classes.sidebarContent}>
        {children}
      </div>
    </div>
  );
}

export default Sidebar;
